var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticClass: "header-row", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c(
                "el-card",
                { staticClass: "box-card machine-card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("CenterForSorting.currentDevice"))
                        ),
                      ]),
                      _c(
                        "span",
                        { staticClass: "machine-select-wrap" },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "280px" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "CenterForSorting.pleaseChoose"
                                ),
                                filterable: "",
                                size: "small",
                              },
                              on: { change: _vm.handleMachineChange },
                              model: {
                                value: _vm.machineId,
                                callback: function ($$v) {
                                  _vm.machineId = $$v
                                },
                                expression: "machineId",
                              },
                            },
                            _vm._l(_vm.machineList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.machineName,
                                  value: String(item.id),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { float: "right" } },
                        [
                          _c(
                            "el-tag",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { type: "success" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("CenterForSorting.open")) +
                                  ": " +
                                  _vm._s(_vm.openChuteCount) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-tag",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { type: "info" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CenterForSorting.close")) +
                                  ": " +
                                  _vm._s(_vm.machineInfo.closedChuteCount) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-tag",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { type: "warning" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CenterForSorting.fullBag")) +
                                  ": " +
                                  _vm._s(_vm.machineInfo.fullBagCount) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions",
                    {
                      attrs: {
                        column: 3,
                        border: "",
                        direction: "vertical",
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("CenterForSorting.machineName"),
                          },
                        },
                        [_vm._v(_vm._s(_vm.machineInfo.machineName) + " ")]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("CenterForSorting.machineCode"),
                          },
                        },
                        [_vm._v(_vm._s(_vm.machineInfo.machineCode) + " ")]
                      ),
                      _c(
                        "el-descriptions-item",
                        {
                          attrs: {
                            label: _vm.$t("CenterForSorting.totalChutes"),
                          },
                        },
                        [_vm._v(_vm._s(_vm.machineInfo.chuteCount) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c("el-card", { staticClass: "box-card notice-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("i", { staticClass: "el-icon-bell notice-icon" }),
                    _c("span", { staticClass: "notice-title" }, [
                      _vm._v(_vm._s(_vm.$t("CenterForSorting.fullBagNotice"))),
                    ]),
                    _c(
                      "el-tag",
                      {
                        staticStyle: { float: "right" },
                        attrs: {
                          type: _vm.noticeTotal ? "warning" : "info",
                          size: "mini",
                        },
                      },
                      [_vm._v(_vm._s(_vm.noticeTotal) + " ")]
                    ),
                  ],
                  1
                ),
                _vm.noticeList.length
                  ? _c("div", { staticClass: "notice-list" }, [
                      _c(
                        "div",
                        { staticClass: "notice-items" },
                        _vm._l(_vm.noticeList, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: _vm.getNoticeKey(item) + "_" + index,
                              staticClass: "notice-item",
                              attrs: {
                                title: _vm.$t(
                                  "CenterForSorting.fullBagNoticeTip"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleNoticeClick(item)
                                },
                              },
                            },
                            [
                              _c("span", {
                                staticClass: "notice-dot",
                                class: item.recoverTime
                                  ? "dot-recovered"
                                  : "dot-full",
                              }),
                              _c("div", { staticClass: "notice-text" }, [
                                _c("span", { staticClass: "notice-chute-no" }, [
                                  _vm._v(_vm._s(item.chuteNumber) + "："),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.fullBagText ||
                                        _vm.$t("CenterForSorting.fullBag")
                                    ) +
                                      "，" +
                                      _vm._s(item.fullBagTime)
                                  ),
                                ]),
                                item.recoverTime
                                  ? _c(
                                      "span",
                                      { staticClass: "notice-recover" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.recoverText ||
                                                _vm.$t(
                                                  "CenterForSorting.recoverNormal"
                                                )
                                            ) +
                                            "，" +
                                            _vm._s(item.recoverTime) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm.hasMoreNotice
                        ? _c(
                            "div",
                            {
                              staticClass: "notice-more",
                              on: { click: _vm.loadMoreNotice },
                            },
                            [
                              _vm.noticeLoadingMore
                                ? _c("i", { staticClass: "el-icon-loading" })
                                : [
                                    _c("i", {
                                      staticClass: "el-icon-arrow-down",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "CenterForSorting.clickLoadMore"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ],
                            ],
                            2
                          )
                        : _c("div", { staticClass: "notice-more is-end" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CenterForSorting.noMoreData"))
                            ),
                          ]),
                    ])
                  : _c("div", { staticClass: "notice-empty" }, [
                      _c("i", { staticClass: "el-icon-bell" }),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("CenterForSorting.noFullBagNotice"))
                        ),
                      ]),
                    ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "filter-container sticky-toolbar",
          staticStyle: {
            "margin-bottom": "20px",
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-refresh",
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.fetchData },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.refresh")) + " ")]
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px", margin: "0 10px" },
                  attrs: {
                    placeholder: _vm.$t("CenterForSorting.autoRefresh"),
                    size: "small",
                  },
                  on: { change: _vm.handleAutoRefresh },
                  model: {
                    value: _vm.autoRefresh,
                    callback: function ($$v) {
                      _vm.autoRefresh = $$v
                    },
                    expression: "autoRefresh",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.closeAutoRefresh"),
                      value: 0,
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.refresh30s"),
                      value: 30,
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("CenterForSorting.refresh60s"),
                      value: 60,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.allExportOrder },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("tablePrice.exportCompartmentData")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:sortingManagementNew:chuteView:clearGridCell",
                      expression:
                        "'btn:sortingManagementNew:chuteView:clearGridCell'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.clearGridCell },
                },
                [_vm._v(_vm._s(_vm.$t("changepwd.clearCompartment")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:sortingManagementNew:chuteView:closeGridCell",
                      expression:
                        "'btn:sortingManagementNew:chuteView:closeGridCell'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.closeGridCell },
                },
                [_vm._v(_vm._s(_vm.$t("changepwd.closeAllCompartment")) + " ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "legend" }, [
            _c("span", { staticClass: "legend-item" }, [
              _c("span", { staticClass: "color-box status-1" }),
              _vm._v(_vm._s(_vm.$t("CenterForSorting.open"))),
            ]),
            _c("span", { staticClass: "legend-item" }, [
              _c("span", { staticClass: "color-box status-0" }),
              _vm._v(_vm._s(_vm.$t("CenterForSorting.close"))),
            ]),
            _c("span", { staticClass: "legend-item" }, [
              _c("span", { staticClass: "color-box status-2" }),
              _vm._v(_vm._s(_vm.$t("CenterForSorting.fullBag"))),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "chute-grid",
        },
        _vm._l(_vm.chuteList, function (chute) {
          return _c(
            "div",
            {
              key: chute.chuteNumber,
              ref: "chuteCard_" + chute.chuteNumber,
              refInFor: true,
              staticClass: "chute-card",
              class: "status-" + chute.chuteStatus,
            },
            [
              _c(
                "div",
                { staticClass: "chute-header" },
                [
                  _c("span", { staticClass: "chute-number" }, [
                    _vm._v(_vm._s(chute.chuteNumber)),
                  ]),
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getStatusType(chute.chuteStatus),
                        size: "mini",
                      },
                    },
                    [_vm._v(_vm._s(_vm.getStatusText(chute.chuteStatus)) + " ")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "chute-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "rule-name",
                    attrs: { title: chute.ruleName },
                  },
                  [
                    _c("span", { staticClass: "rule-name-text" }, [
                      _vm._v(
                        _vm._s(
                          chute.ruleName || _vm.$t("CenterForSorting.noRule")
                        )
                      ),
                    ]),
                    chute.ruleName
                      ? _c("i", {
                          staticClass: "el-icon-tickets",
                          staticStyle: {
                            cursor: "pointer",
                            color: "#00a551",
                            "margin-left": "5px",
                            "flex-shrink": "0",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleRuleDetail(chute)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "bag-count",
                    class: {
                      "bag-count-highlight": Number(chute.bagCount) > 0,
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("CenterForSorting.bagCount")) +
                        ": " +
                        _vm._s(chute.bagCount) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:sorting:chuteView:operation",
                      expression: "'btn:sorting:chuteView:operation'",
                      arg: "remove",
                    },
                  ],
                  staticClass: "chute-actions",
                },
                [
                  _c(
                    "el-dropdown",
                    {
                      attrs: { trigger: "click" },
                      on: {
                        command: function (cmd) {
                          return _vm.handleCommand(cmd, chute)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "el-dropdown-link",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CenterForSorting.operation"))
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right",
                          }),
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: chute.chuteStatus === 1,
                                command: "open",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CenterForSorting.open")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: chute.chuteStatus === 0,
                                command: "close",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CenterForSorting.close")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: chute.chuteStatus === 2,
                                command: "full",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CenterForSorting.setFull")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "clear", divided: "" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CenterForSorting.clearData")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      _c("rule-condition-detail", {
        attrs: {
          "condition-configs": _vm.conditionConfigs,
          "rule-id": _vm.currentRuleId,
          visible: _vm.viewConditionsVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.viewConditionsVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }